import { GlobalStyles } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';

const StyledNotistack = () => {
  const theme = useTheme();

  const isLight = theme.palette.mode === 'light';

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '#root': {
          '.notistack-MuiContent': {
            '&.notistack-MuiContent-success, &.notistack-MuiContent-error, &.notistack-MuiContent-warning, &.notistack-MuiContent-info':
              {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              },
            backgroundColor: isLight
              ? theme.palette.grey[900]
              : theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.customShadows.z8,
            color: isLight
              ? theme.palette.common.white
              : theme.palette.grey[800],
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
};

export default StyledNotistack;
